// src/data/exercises/L1_02.js

const accountOptions = [
  '現金', '定期預金', '普通預金', '当座預金', '資本金'];

export const L1_02 = {
  title: '簿記　3級（第217-2回）',
  questions: [
    {
      id: 'q1',
      type: 'JOURNAL_ENTRY',
        content: {
       parts: [
        { type: 'ruby', text: '和歌山', ruby: 'わかやま' },
        { type: 'ruby', text: '株式会社', ruby: 'かぶしきがいしゃ' },
        { type: 'text', value: 'は，' },
        { type: 'ruby', text: '手', ruby: 'て' },
        { type: 'text', value: 'もとにある' },
        { type: 'ruby', text: '現金', ruby: 'げんきん' },
        { type: 'text', value: '￥1,000,000のうち，￥400,000を' },
        { type: 'ruby', text: '定期預金', ruby: 'ていきよきん' },
        { type: 'ruby', text: '口座', ruby: 'こうざ' },
        { type: 'text', value: 'に' },
        { type: 'ruby', text: '預け入れ', ruby: 'あずけいれ' },
        { type: 'text', value: '，' },
        { type: 'ruby', text: '残額', ruby: 'ざんがく' },
        { type: 'text', value: 'は' },
        { type: 'ruby', text: '普通預金', ruby: 'ふつうよきん' },
        { type: 'ruby', text: '口座', ruby: 'こうざ' },
        { type: 'text', value: 'に' },
        { type: 'ruby', text: '預', ruby: 'あず' },
        { type: 'text', value: 'け' },
　　　　 { type: 'ruby', text: '入', ruby: 'い' },
        { type: 'text', value: 'れた。' }
    ]
      },
      table: {
        options: accountOptions,
      },
      // Đáp án có 1 dòng Nợ và 2 dòng Có
      answer: [
        { debitAccount: '定期預金', debitAmount: 400000, creditAccount: '現金', creditAmount: 1000000 },
        { debitAccount: '普通預金', debitAmount: 600000, creditAccount: null, creditAmount: null },
              ],
       // Giải thích chi tiết khi trả lời ĐÚNG (có định dạng)
      explanation_correct: {
        parts: [
          { type: 'text', value: '「￥400,000を定期預金口座に預け入れ」なので、\n' },
          { type: 'text', value: '①定期預金が増加（プラス）します。\n' },
          { type: 'styled', value: '定期預金の増加（プラス）は借方（左・Ｄｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: 'このときの普通預金の金額は1,000,000－定期預金400,000＝？\n' },
          { type: 'styled', value: '普通預金の増加（プラス）は借方（左・Ｄｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'styled', value: '金額は1,000,000－400,000＝600,000となります。\n\n', color: 'red', bold: true },
          { type: 'text', value: '「手もとにある現金￥1,000,000のうち・・・に預け入れた」なので、\n' },
          { type: 'text', value: '③現金を預け入れたとあるので現金が減少（マイナス）します。\n' },
          { type: 'styled', value: '現金の減少（マイナス）は貸方（右・Ｃｒ）に記入します。\n\n', color: 'red', bold: true },
        ]
      },

      // Gợi ý 2 cấp độ khi trả lời SAI
      hints: {
        account: [
          // Gợi ý lần 1, 2
` 「￥400,000を定期預金口座に預け入れ」なので、
①定期預金が増加（プラス）します。
残額は普通預金口座に預け入れた」なので、
②普通預金が増加（プラス）します。
このときの普通預金の金額は1,000,000－定期預金400,000＝？

「手もとにある現金￥1,000,000のうち・・・に預け入れた」なので、
③現金を預け入れたとあるので現金が減少（マイナス）します。  `,
          // Gợi ý lần 3 (chi tiết hơn, có định dạng)
          {
            parts: [
          { type: 'text', value: '「￥400,000を定期預金口座に預け入れ」なので、\n' },
          { type: 'text', value: '①定期預金が増加（プラス）します。\n' },
          { type: 'styled', value: '定期預金の増加（プラス）は借方（左・Ｄｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: 'このときの普通預金の金額は1,000,000－定期預金400,000＝？\n' },
          { type: 'styled', value: '普通預金の増加（プラス）は借方（左・Ｄｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'styled', value: '金額は1,000,000－400,000＝600,000となります。\n\n', color: 'red', bold: true },
          { type: 'text', value: '「手もとにある現金￥1,000,000のうち・・・に預け入れた」なので、\n' },
          { type: 'text', value: '③現金を預け入れたとあるので現金が減少（マイナス）します。\n' },
          { type: 'styled', value: '現金の減少（マイナス）は貸方（右・Ｃｒ）に記入します。\n\n', color: 'red', bold: true },
        ]
          }
        ],
        
      },
    },
  ],
};